import { render, staticRenderFns } from "./CustomerRegistration.vue?vue&type=template&id=30d83a3b"
import script from "./CustomerRegistration.vue?vue&type=script&lang=js"
export * from "./CustomerRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports